import React from "react";
import { observer, inject } from "mobx-react";
import * as Icon from "react-feather";
import SurveyResultsFilter from "./survey-results-filter";
import SurveyResultsResponses from "./survey-results-responses";
import ReactMarkdown from "react-markdown";
import * as H from "../helpers";
import * as M from "@material-ui/core";
import * as Chart from "recharts";

const SurveyResults = props => {
  const { $survey, $user, $locale, $question, $group, $config, $router, $respondent } = props.store;
  let uid = $router.getURLParameterByName("uid") || $user.sessionUser.uid;

  console.log("re", $survey.selected.responsesForSelectedGroup);

  return (
    $survey.selected && (
      <div>
        <div className="flex justify-between">
          <h2>Resultaten</h2>
          {$user.sessionUser.isCreator ? (
            <div className="flex items-center">
              <M.Button onClick={() => $survey.selected.resultsToXls()}>Export (XLS)</M.Button>
              <Icon.Printer onClick={() => window.print()} />
            </div>
          ) : (
            <Icon.Printer className="pointer hide-for-print" onClick={() => window.print()} />
          )}
        </div>

        {$user.sessionUser.isVerifiedMentor && <SurveyResultsFilter />}

        {!$user.sessionUser.isVerifiedCreator &&
          (($group.selected && $group.selected.respondentCountForSelectedSurvey) ||
            !$group.selected) && (
            <ReactMarkdown
              className="mt-4"
              source={$locale.t($survey.selected._key + "_feedback")}
            />
          )}

        <div className="mt-6">
          {$config.results
            .filter(result => result.surveyKey === $survey.selected._key)
            .map(fieldset => {
              const level1 = $question.list.get(fieldset.key);
              let averageFieldset = null;
              let dataRadar = [];

              fieldset.branches &&
                fieldset.branches.forEach(branch => {
                  branch.values = { group: [], individual: [] };
                });

              if (fieldset.id === "1_1" && level1) {
                level1.children.forEach((child, i) => {
                  let index = fieldset.branches.findIndex(
                    branch => branch.match.indexOf(child._key) > -1
                  );

                  // GROUP
                  if ($group.selected) {
                    let answersGroup = child.getAnswerValuesForGroup($group.selected._key);

                    index > -1 &&
                      answersGroup &&
                      fieldset.branches[index].values.group.push(...answersGroup);
                  }

                  // INDIVIDUEEL
                  let answersIndividual = child.getAnswerValuesForIndividual(uid);

                  index > -1 &&
                    answersIndividual &&
                    fieldset.branches[index].values.individual.push(...answersIndividual);
                });

                fieldset.branches.forEach(branch => {
                  let branchObject = {
                    subject: branch.label,
                    fullMark: 6,
                    individual: branch.values.individual.length
                      ? branch.values.individual.reduce((a, b) => Number(a) + Number(b)) /
                        branch.values.individual.length
                      : null,
                    reference: branch.reference,
                    group:
                      branch.values.group.length &&
                      branch.values.group.reduce((a, b) => Number(a) + Number(b)) /
                        branch.values.group.length
                  };
                  dataRadar.push(branchObject);
                });
              }

              if (fieldset.id === "1_2" && level1) {
                averageFieldset = {
                  name: "1_2",
                  individueel: level1.getAverageAnswerValue({
                    by: "uid",
                    value: uid
                  }),
                  referentie: fieldset.reference,
                  groep: level1.getAverageAnswerValue({
                    by: "groupKey",
                    value: $group.selected && $group.selected._key
                  })
                };
              }

              if (fieldset.id === "2_1" && level1) {
                let question = $survey.selected.questionTree.find(q => q._key === fieldset.key);

                question &&
                  question.children.forEach(_group => {
                    _group = $question.list.get(_group._key);
                    const reference =
                      fieldset.branches &&
                      fieldset.branches.find(branch => branch.match === _group._key) &&
                      fieldset.branches.find(branch => branch.match === _group._key).reference;
                    const individual = _group.getAverageAnswerValue({
                      by: "uid",
                      value: uid
                    });
                    const group = _group.getAverageAnswerValue({
                      by: "groupKey",
                      value: $group.selected && $group.selected._key
                    });

                    if (group > 0 || individual > 0) {
                      if (
                        ($user.sessionUser.isAnonymous && individual) ||
                        !$user.sessionUser.isAnonymous
                      ) {
                        dataRadar.push({
                          subject: $locale.t(_group._key),
                          individual,
                          reference,
                          ...(group !== false && { group }),
                          fullMark: 7
                        });
                      }
                    }
                  });
              }

              return (
                (dataRadar.length > 0 || averageFieldset) && (
                  <div key={fieldset.key} className="border border-gray p-6 mb-6 bg-gray-lightest">
                    <div className="bg-white p-8 mb-6 flex flex-column justify-center items-center">
                      {dataRadar.length > 0 && (
                        <Chart.RadarChart
                          outerRadius={140}
                          width={600}
                          height={400}
                          data={dataRadar}
                        >
                          <Chart.PolarGrid />
                          <Chart.PolarAngleAxis width={200} dataKey="subject" />
                          <Chart.PolarRadiusAxis
                            angle={90}
                            domain={[0, fieldset.id === "2_1" ? 8 : 6]}
                          />

                          {dataRadar.some(b => b.individual) && (
                            <Chart.Radar
                              name="Individueel"
                              dataKey="individual"
                              stroke="#007db3"
                              fill="#007db3"
                              fillOpacity={0.6}
                            />
                          )}

                          {dataRadar.some(b => b.group) && (
                            <Chart.Radar
                              name={$group.selected && $group.selected.name}
                              dataKey="group"
                              stroke="#eecc11"
                              fill="#eecc11"
                              fillOpacity={0.6}
                            />
                          )}

                          {dataRadar.some(b => b.reference) && (
                            <Chart.Radar
                              name="Referentie"
                              dataKey="reference"
                              stroke="#1b905c"
                              fillOpacity={0}
                              strokeWidth={2}
                            />
                          )}

                          <Chart.Tooltip />
                          <Chart.Legend />
                        </Chart.RadarChart>
                      )}
                      {averageFieldset &&
                        (averageFieldset.individueel ||
                          averageFieldset.referentie ||
                          averageFieldset.groep) && (
                          <Chart.BarChart width={500} height={400} data={[averageFieldset]}>
                            <Chart.CartesianGrid strokeDasharray="3 3" />
                            <Chart.YAxis domain={[0, 6]} />
                            />
                            <Chart.Legend tick={{ fontSize: 20, fill: "red" }} />
                            {averageFieldset.individueel && (
                              <Chart.Bar dataKey="individueel" fill="#007db3" />
                            )}
                            {averageFieldset.groep && <Chart.Bar dataKey="groep" fill="#eecc11" />}
                            {averageFieldset.referentie && (
                              <Chart.Bar dataKey="referentie" fill="#1b905c" />
                            )}
                          </Chart.BarChart>
                        )}
                    </div>
                    <div>
                      <h3 className="mb-4">{level1 && $locale.t(level1._key)}</h3>
                      {averageFieldset && averageFieldset.individueel ? (
                        <div>
                          <b>Uw gemiddelde score</b>:{" "}
                          {Math.round(averageFieldset.individueel * 100) / 100}
                        </div>
                      ) : (
                        false
                      )}
                      {averageFieldset && averageFieldset.groep && (
                        <div>
                          Gemiddelde score voor {$group.selected && $group.selected.name}:{" "}
                          {Math.round(averageFieldset.groep * 100) / 100}
                        </div>
                      )}
                      {averageFieldset && averageFieldset.referentie && (
                        <div>
                          Gemiddelde referentiescore:{" "}
                          {Math.round(averageFieldset.referentie * 100) / 100}
                        </div>
                      )}

                      <ReactMarkdown
                        source={level1 && $locale.t(level1._key + "_feedback")}
                        className="mt-4 "
                      />

                      {level1.children.sort(H.compare("order", "asc")).map(
                        child =>
                          $locale.t(child._key + "_feedback") && (
                            <div className="mb3" key={child}>
                              <h4>{$locale.t(child._key)}</h4>
                              <ReactMarkdown
                                source={level1 && $locale.t(child._key + "_feedback")}
                                className="mt-4"
                              />
                            </div>
                          )
                      )}
                    </div>
                  </div>
                )
              );
            })}
        </div>

        {$user.sessionUser.isVerifiedCreator && (
          <div>
            <SurveyResultsResponses />
          </div>
        )}
      </div>
    )
  );
};

export default inject("store")(observer(SurveyResults));
